import { COOKIE_CCPA_CONSENT } from 'common/cookies/Cookies';
import { getCcpaConsentCookieProperties, ICcpaConsent } from 'common/cookies/CookieUtils';
import { StorageKeys } from 'common/storage/constants';
import Cookies from 'js-cookie';
import { getBrowserStorage } from 'src/shared/storage/Storage';
import { getDomain } from 'src/shared/utils/RouteUtilities';

/**
 * The stored ad-consent decision, cookie first.
 *
 * localStorage is read only to carry over visitors who decided before the cookie existed;
 * it cannot be the source of truth because it is scoped per origin, so a decision made on
 * shef.com never reaches the `/lp/` pages or a partner subdomain.
 */
export function readRawCcpaConsent(): string | null {
  const fromCookie = Cookies.get(COOKIE_CCPA_CONSENT);
  if (fromCookie) {
    return fromCookie;
  }
  try {
    return getBrowserStorage().getItem(StorageKeys.CCPA_CONSENT);
  } catch {
    return null;
  }
}

export function writeCcpaConsent(preferences: ICcpaConsent): void {
  const serialized = JSON.stringify(preferences);
  Cookies.set(COOKIE_CCPA_CONSENT, serialized, getCcpaConsentCookieProperties(getDomain(window.location.hostname)));
  try {
    getBrowserStorage().setItem(StorageKeys.CCPA_CONSENT, serialized);
  } catch {
    // storage unavailable; the cookie above is the source of truth
  }
}
